import React, { useEffect, useRef, useState } from "react";

const Mission = ({ data }) => {
  const missionPage = data.page.find(
    (p) => p.title.toLowerCase() === "mission & vision"
  );

  const mission = missionPage.sections[0];
  const vision = missionPage.sections[1];
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const renderBlock = (item, direction) => (
    <div
      className={`space-y-3 transition-all duration-[1400ms] ease-out ${
        isVisible
          ? "opacity-100 translate-x-0"
          : direction === "left"
          ? "-translate-x-6 opacity-0"
          : "translate-x-6 opacity-0"
      }`}
      style={{
        transitionDelay: isVisible
          ? direction === "left"
            ? "150ms"
            : "300ms"
          : "0ms",
      }}
    >
      <p className="text-xs sm:text-sm md:text-lg font-semibold uppercase tracking-[0.3em] text-black/60 leading-tight">
        {item.heading}
      </p>
      <div
        className="text-base sm:text-lg md:text-xl text-black/85 leading-relaxed text-justify"
        dangerouslySetInnerHTML={{ __html: item.content }}
      />
    </div>
  );

  return (
    <section
      ref={sectionRef}
      className="py-16 md:py-24 bg-ofWhite px-4 overflow-hidden"
    >
      <div className="max-w-6xl mx-auto relative py-6 md:py-10">
        <span
          className={`pointer-events-none hidden md:block absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-px bg-black/60 origin-top transition-transform duration-[1200ms] ${
            isVisible ? "scale-y-100" : "scale-y-0"
          }`}
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 relative">
          {renderBlock(mission, "left")}
          {renderBlock(vision, "right")}
        </div>
      </div>
    </section>
  );
};

export default Mission;
